import { createApi, save } from "./common";

const accountingApi = createApi(process.env.REACT_APP_ACCOUNTING_API_URL);
export default accountingApi;

const coaEndpoint = "/accounts";

export const findAccounts = () => accountingApi.get(coaEndpoint);

export const saveAccount = (payload) =>
  save(accountingApi)(coaEndpoint)(payload);

export const deleteAccount = (accountId) =>
  accountingApi.delete(`${coaEndpoint}/${accountId}`);
